// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4MOi5","title":"styles_title__mSWDe","search":"styles_search__7IhhD"};